import PropTypes from "prop-types";
import { PieChart, Pie, Cell, Tooltip, Label, ResponsiveContainer } from "recharts";
import { formatNumber } from "../../utils/utils";

/**
 * Renders a responsive DonutChart (PieChart with inner radius) to visualize partitioned power values.
 * @param {Object} hookData - Contains donutData and totalPower.
 * @param {Array<{ name: string, value: number }>} hookData.donutData - The chart segments.
 * @param {number} hookData.totalPower - Total value displayed in the center.
 * @param {string[]} colors - Array of colors for chart segments.
 * @returns {JSX.Element}
 */
const DonutChart = ({ hookData, unit, colors }) => {
  if (!hookData || !Array.isArray(hookData.donutData) || hookData.donutData.length === 0) {
    console.error("Invalid or empty data provided to DonutChart.");
    return <div>Keine Daten verfügbar</div>;
  }

  const { donutData, totalPower } = hookData;

  return (
    <div className="w-full max-w-[220px] aspect-square mx-auto">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart width={200} height={200}>
          <Pie
            data={donutData}
            innerRadius="60%"
            outerRadius="80%"
            paddingAngle={5}
            startAngle={-270}
            dataKey="value"
          >
            {donutData.map((entry, idx) => (
              <Cell key={`cell-${idx}`} fill={colors[idx % colors.length]} />
            ))}
            <Label
              value={`${formatNumber(totalPower, 1, 1)} ${unit}`}
              position="center"
              className="text-sm font-bold"
            />
          </Pie>
          <Tooltip formatter={(value) => `${formatNumber(value, 1, 1)} ${unit}`} />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

DonutChart.propTypes = {
  hookData: PropTypes.shape({
    donutData: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired,
        unit: PropTypes.string,
      })
    ).isRequired,
    totalPower: PropTypes.number.isRequired,
  }).isRequired,
  unit: PropTypes.string.isRequired,
  colors: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default DonutChart;
